import TalentCareerPrice from "./TalentCareerPrice.vue"

export default function install(Vue) {
  Vue.component(TalentCareerPrice.name, TalentCareerPrice)
}
